import { Col, Row, Typography } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { dashboardBoxes } from './dashboardBoxes';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const AdminDashboard = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '24px' }}>
      {/* Header */}
      <div style={{ marginBottom: 28 }}>
        <Title level={3} style={{ margin: 0, fontWeight: 600 }}>
          Admin Dashboard
        </Title>
        <Text type="secondary">
          Manage your branches, users, roles and system settings.
        </Text>
      </div>

      {/* Cards */}
      <Row gutter={[20, 20]}>
        {dashboardBoxes.map((box) => (
          <Col xs={24} sm={12} lg={8} key={box.key}>
            <div
              role="button"
              tabIndex={0}
              onClick={() => navigate(box.route)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') navigate(box.route);
              }}
              className="admin-dashboard-card"
              style={{ '--accent': box.accent }}
            >
              <div
                className="admin-dashboard-card__icon"
                style={{ background: box.tint, color: box.accent }}
              >
                {box.icon}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="admin-dashboard-card__title">{box.title}</div>
                <div className="admin-dashboard-card__desc">
                  {box.description}
                </div>
              </div>
              <RightOutlined className="admin-dashboard-card__arrow" />
            </div>
          </Col>
        ))}
      </Row>

      <style>{`
        .admin-dashboard-card {
          display: flex;
          align-items: center;
          gap: 16px;
          height: 100%;
          padding: 20px;
          background: #fff;
          border: 1px solid #f0f0f0;
          border-radius: 14px;
          cursor: pointer;
          outline: none;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
          transition: transform 0.2s ease, box-shadow 0.2s ease,
            border-color 0.2s ease;
        }
        .admin-dashboard-card:hover,
        .admin-dashboard-card:focus-visible {
          transform: translateY(-4px);
          border-color: var(--accent);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
        }
        .admin-dashboard-card__icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 56px;
          height: 56px;
          border-radius: 12px;
          flex-shrink: 0;
          transition: transform 0.2s ease;
        }
        .admin-dashboard-card:hover .admin-dashboard-card__icon {
          transform: scale(1.06);
        }
        .admin-dashboard-card__title {
          font-size: 15px;
          font-weight: 600;
          color: #1f1f1f;
          margin-bottom: 4px;
        }
        .admin-dashboard-card__desc {
          font-size: 12.5px;
          color: #8c8c8c;
          line-height: 1.5;
        }
        .admin-dashboard-card__arrow {
          color: #bfbfbf;
          font-size: 13px;
          flex-shrink: 0;
          transition: transform 0.2s ease, color 0.2s ease;
        }
        .admin-dashboard-card:hover .admin-dashboard-card__arrow {
          color: var(--accent);
          transform: translateX(3px);
        }
      `}</style>
    </div>
  );
};

export default AdminDashboard;
